const Minus = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 24 24' fill='none'>
			<path
				d='M4.8125 12.8379C4.65625 12.8379 4.51302 12.7988 4.38281 12.7207C4.2526 12.6426 4.14518 12.5384 4.06055 12.4082C3.98242 12.2715 3.94336 12.1217 3.94336 11.959C3.94336 11.8027 3.98242 11.6595 4.06055 11.5293C4.14518 11.3926 4.2526 11.2852 4.38281 11.207C4.51302 11.1289 4.65625 11.0898 4.8125 11.0898H19.1875C19.3438 11.0898 19.487 11.1289 19.6172 11.207C19.7539 11.2852 19.8613 11.3926 19.9395 11.5293C20.0176 11.6595 20.0566 11.8027 20.0566 11.959C20.0566 12.1217 20.0176 12.2715 19.9395 12.4082C19.8613 12.5384 19.7539 12.6426 19.6172 12.7207C19.487 12.7988 19.3438 12.8379 19.1875 12.8379H4.8125Z'
				fill='#21242D'
			/>
		</svg>
	);
};

export default Minus;
